// extracted by mini-css-extract-plugin
module.exports = {"b12d6d7k":"b12d6d7k"};